import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelConfiguration from './ModelConfiguration';
import { getModelManager, getUserProfileWidget } from '../../selectors/index';
import { describeModelThunk, modelCleanUpThunk } from '../../actions/model';

const mapStateToProps = state => {
    return {
        modelManager: getModelManager(state),
        userProfileWidgets: getUserProfileWidget(state)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            describeModel: (modelId, isDuplicate, modelCategoryId, fetchModelCategoryData, fetchModelData) => describeModelThunk(modelId, isDuplicate, 'MODEL_CONFIGURE', modelCategoryId, fetchModelCategoryData, fetchModelData),
            modelCleanUpThunk: model => modelCleanUpThunk(model)
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ModelConfiguration);
